module.exports = __webpack_public_path__ + "img/zcjj.428c5c0c.png";